import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    createUpdateServiceRateCard
} from '../../store/actions/serviceRateCard.action';
import { getSelectList } from "../../config/utils";
import { fetchCompanyFilters } from "../../store/actions/rateCard";
import { getAllSellersList } from "../../store/actions";
import { getSellerWarehouseService } from "../../services/company.service";
import moment from "moment";
import { toast } from "react-toastify";
import _ from "lodash";
import ServiceRateCardComponent from "./Services";
import { getCompanySellerRateCardsService } from "../../store/actions/inventory.action";
import PropTypes from 'prop-types';

/* istanbul ignore next */
const ServiceRateCard = (props) => {
    const location = useLocation();
    const { isEditable = false } = props;
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { filterCompanies } = useSelector((state) => state.RateCardReducer);
    const [companyList, setCompanyList] = useState([]);
    const [sellerList, setSellerList] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [selectedWarehouse_Id, setSelectedWarehouse_Id] = useState(0);
    const rateCardDetails = location?.state?.rateCardDetails;
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);

    const [error, setErrors] = useState({
        serviceDetails: [
            {
                serviceType_Id: "",
                transactionType_Id: "",
                packingType_Id: "",
                sizeType_Id: "",
                unit_Id: "",
                billingCycle_Id: "",
                amount: "",
                additionalCharge: "",
            }
        ]
    });

    const serviceRateCardObj = {
        isActive: true,
        id: 0,
        selectedCompany_Id: 0,
        selectedSeller_Id: 0,
        seller_Id: 0,
        serviceDetails: [
            {
                id: Number(id),
                details_Id: 0,
                serviceType_Id: 0,
                transactionType_Id: 0,
                packingType_Id: 0,
                sizeType_Id: 0,
                unit_Id: 0,
                billingCycle_Id: 0,
                amount: "",
                additionalCharge: "",
                isServiceActive: false,
            }
        ],
        selectedWarehouse_Id: 0
    }

    const [formData, setFormData] = useState({});

    const handleBack = () => {
        navigate('/accounting/service-rate-card');
    };

    const fetchData = async () => {
        try {
            let data = {
                "pageIndex": 1,
                "pageSize": 150,
                "sortColumn": "",
                "sortOrder": "ASCENDING",
                "searchkey": "",
                "selectedCompany_Id": rateCardDetails?.CompanyId,
                "selectedSeller_Id": rateCardDetails?.SellerId,
                "selectedDateTime": moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
                "selectedWarehouse_Id": selectedWarehouse_Id || rateCardDetails?.WarehouseId
            }
            const res = await getCompanySellerRateCardsService(data);
            setFormData({ ...serviceRateCardObj, serviceDetails: res.data.Entity.RateCards });
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (!rateCardDetails?.CompanyId) {
            navigate('/accounting/service-rate-card');
        }
    }, [rateCardDetails]);

    useEffect(() => {
        if (Number(id) > 0) {
            let data = {
                pageIndex: 1,
                pageSize: 10,
                sortColumn: "name",
                sortOrder: "ascending",
            };
            dispatch(fetchCompanyFilters(data));
            fetchData();
        }
    }, [id]);

    useEffect(() => {
        let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
        setCompanyList(getSelectList(companyList, 'Id', 'name'));
    }, [filterCompanies]);

    const fetchSellers = async (activeSellerList) => {
        let data = {
            companyIds: [activeSellerList],
        };
        let res = await getAllSellersList(data);
        if (res?.data?.Status === 200) {
            let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
                (item) => {
                    return {
                        ...item,
                        label: item.sellerAndCompany,
                        value: item.id,
                    };
                }
            );

            setSellerList(dataList);
        }
    };

    const fetchWarehouses = async (sellerId) => {
        try {
            let data = {
                companyId: rateCardDetails?.CompanyId,
                sellerId: sellerId,
                tenantId: 0 // This will be overridden by the server based on JWT token
            };
            let res = await getSellerWarehouseService(data);
            if (res?.data?.Status === 200 && res?.data?.EntityList) {
                let dataList = res.data.EntityList.map((item) => {
                    return {
                        id: item.Warehouse_Id,
                        label: item.WarehouseName,
                        value: item.Warehouse_Id,
                        ...item
                    };
                });
                setWarehouseList(dataList);
                // Set default warehouse to first item if not already set
                if (!selectedWarehouse_Id && dataList.length > 0) {
                    setSelectedWarehouse_Id(dataList[0].id);
                }
            } else {
                console.warn('No warehouses found or API error:', res?.data);
                setWarehouseList([]);
            }
        } catch (error) {
            console.error('Error fetching warehouses:', error);
            setWarehouseList([]);
        }
    };

    useEffect(() => {
        if (rateCardDetails?.CompanyId) {
            let companyData = rateCardDetails?.CompanyId;
            fetchSellers(companyData);
        }
    }, [rateCardDetails?.CompanyId]);

    useEffect(() => {
        if (rateCardDetails?.SellerId) {
            let sellerData = rateCardDetails?.SellerId;
            fetchWarehouses(sellerData);
        }
    }, [rateCardDetails?.SellerId]);

    // Fetch data again when selectedWarehouse_Id is set for the first time
    useEffect(() => {
        if (selectedWarehouse_Id > 0) {
            fetchData();
        }
    }, [selectedWarehouse_Id]);

    const handleServiceDetailChange = (event, index) => {
        const { value, name } = event.target;
        let data = _.cloneDeep(formData);
        let errorData = _.cloneDeep(error);
        data.serviceDetails[index][name] = value;
        setFormData(data);
        errorData.serviceDetails[index][name] = '';
        setErrors(errorData);
    }

    const handleInputBlur = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.trim() });
        setErrors({ ...error, [name]: '' });
    };

    const handleDateChange = (value, name, index) => {
        let data = _.cloneDeep(formData);
        data.serviceDetails[index][name] = value;
        setFormData(data);
    }

    const handleCreateUpdateServiceRateCard = async (rateCard, actionType) => {
        let dataSave = {
            ...rateCard,
            selectedCompany_Id: rateCardDetails?.CompanyId,
            selectedSeller_Id: rateCardDetails?.SellerId,
            selectedWarehouse_Id: selectedWarehouse_Id || rateCardDetails?.WarehouseId,
            ValidFrom: moment(rateCard.ValidFrom).format("YYYY-MM-DDTHH:mm:ss"),
            ValidTo: rateCard.ValidTo ? moment(rateCard.ValidTo).format("YYYY-MM-DDTHH:mm:ss") : null,
        };

        delete dataSave.IsDefaulRate;
        if (rateCard.ValidFrom && rateCard.ValidTo) {
            if (moment(rateCard.ValidFrom).isAfter(rateCard.ValidTo)) {
                toast.error("Valid From date cannot be after Valid To date.");
                return;
            }
        }
        let res = await Promise.resolve(dispatch(createUpdateServiceRateCard(dataSave)));
        if (res?.data?.Status === 200) {
            toast.success(`Updated successfully`);
            fetchData();
        } else {
            toast.error(res?.data?.Message?.AppStatusDescription);
        }
    };

    const handleServiceDetails = (value, name, index, isNumber = false) => {
        let data = _.cloneDeep(formData);
        data.serviceDetails[index][name] = isNumber ? Number(value) : value;
        setFormData(data);
    };

    const handleWarehouseChange = (e) => {
        const warehouseId = Number.parseInt(e.target.value);
        setSelectedWarehouse_Id(warehouseId);
    };

    return (
        <div className={` ${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <div>
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        {id > 0 && "Edit Service Rate Card"}
                    </span>
                    <div className="top_right_button_container">
                        <div className="top_right_button_container">
                            <button
                                className="btn cus-primary-transparent-btn"
                                onClick={handleBack}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </div>

                <div className="cus-page-content-sec">
                    <div className="incomingAccordion accordion">
                        <div className="row fontFix">
                            <div className="col-lg-12">
                                <Accordion
                                    defaultActiveKey={["0", "1"]}
                                    alwaysOpen={true}
                                >
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            General{" "}
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="row addressForm">
                                                <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                    <label htmlFor="selectedCompany_Id">Company <span className="error">*</span></label>
                                                    <select
                                                        className="form-control selectedCompany_Id"
                                                        value={rateCardDetails?.CompanyId}
                                                        id="selectedCompany_Id"
                                                        name="selectedCompany_Id"
                                                        disabled
                                                    >
                                                        <option value="">Select company..</option>
                                                        {companyList.map((company) => (
                                                            <option key={company.Id} value={company.Id}>
                                                                {company.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className='require-field'>{error.selectedCompany_Id}</div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                    <label htmlFor="selectedSeller_Id">Seller <span className="error">*</span></label>
                                                    <select
                                                        className="form-control selectedSeller_Id"
                                                        value={rateCardDetails?.SellerId}
                                                        id="selectedSeller_Id"
                                                        name="selectedSeller_Id"
                                                        disabled
                                                    >
                                                        <option value="">Select seller..</option>
                                                        {sellerList.map((seller) => (
                                                            <option key={seller.id} value={seller.id}>
                                                                {seller.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className='require-field'>{error.selectedSeller_Id}</div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                    <label htmlFor="selectedWarehouse_Id">Warehouse <span className="error">*</span></label>
                                                    <select
                                                        className="form-control selectedWarehouse_Id"
                                                        value={selectedWarehouse_Id || rateCardDetails?.WarehouseId}
                                                        id="selectedWarehouse_Id"
                                                        name="selectedWarehouse_Id"
                                                        onChange={handleWarehouseChange}
                                                    >
                                                        <option value="">Select warehouse..</option>
                                                        {warehouseList.map((warehouse) => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className='require-field'>{error.selectedWarehouse_Id}</div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                    <label htmlFor="selectedSellerCode">Seller Code</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        id="selectedSellerCode"
                                                        value={rateCardDetails?.SellerCode}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            Services{" "}
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="nested-services-container">
                                                {(() => {
                                                    // Group services by ServiceType with special handling for rent services
                                                    const serviceGroups = {};
                                                    formData?.serviceDetails?.forEach((service, index) => {
                                                        // Get the service type
                                                        const originalServiceType = service.ServiceType || 'default';
                                                        
                                                        // Group "Base Rent" and "Variable Rent" under "Rent"
                                                        // Group all "Carrier Connect *" variants under "Carrier Connect"
                                                        let serviceName;
                                                        if (originalServiceType.includes('Rent')) {
                                                            serviceName = 'Rent';
                                                        } else if (originalServiceType.startsWith('Carrier Connect')) {
                                                            serviceName = 'Carrier Connect';
                                                        } else {
                                                            serviceName = originalServiceType;
                                                        }
                                                        
                                                        if (!serviceGroups[serviceName]) {
                                                            serviceGroups[serviceName] = [];
                                                        }
                                                        serviceGroups[serviceName].push({...service, originalIndex: index});
                                                    });

                                                    return Object.keys(serviceGroups).map((serviceName, groupIndex) => {
                                                        const services = serviceGroups[serviceName];
                                                        const displayName = serviceName === 'default' ? 'Undefined Service' : serviceName;
                                                        
                                                        return (
                                                            <div key={`service-group-${serviceName}-${groupIndex}`} className="nested-service-item">
                                                                <div className="nested-accordion-wrapper">
                                                                    <Accordion defaultActiveKey="0" alwaysOpen={false} className="child-service-accordion">
                                                                        <Accordion.Item eventKey="0" className="child-accordion-item">
                                                                            <Accordion.Header className="child-service-header">
                                                                                <span className="service-type-title">{displayName}</span>
                                                                                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            </Accordion.Header>
                                                                            <Accordion.Body className="child-service-body">
                                                                                <ServiceRateCardComponent
                                                                                    handleServiceDetails={(value, name, index, isNumber) => {
                                                                                        const originalIndex = services[index]?.originalIndex;
                                                                                        if (originalIndex !== undefined) {
                                                                                            handleServiceDetails(value, name, originalIndex, isNumber);
                                                                                        }
                                                                                    }}
                                                                                    handleInputBlur={handleInputBlur}
                                                                                    isEditable={isEditable}
                                                                                    formData={{
                                                                                        ...formData,
                                                                                        serviceDetails: services.map(s => {
                                                                                            const {originalIndex, ...service} = s;
                                                                                            return service;
                                                                                        })
                                                                                    }}
                                                                                    error={{
                                                                                        ...error,
                                                                                        serviceDetails: services.map(s => 
                                                                                            error.serviceDetails[s.originalIndex] || {
                                                                                                serviceType_Id: "",
                                                                                                transactionType_Id: "",
                                                                                                packingType_Id: "",
                                                                                                sizeType_Id: "",
                                                                                                unit_Id: "",
                                                                                                billingCycle_Id: "",
                                                                                                amount: "",
                                                                                                additionalCharge: "",
                                                                                            }
                                                                                        )
                                                                                    }}
                                                                                    handleFormChange={(event, index) => {
                                                                                        const originalIndex = services[index]?.originalIndex;
                                                                                        if (originalIndex !== undefined) {
                                                                                            handleServiceDetailChange(event, originalIndex);
                                                                                        }
                                                                                    }}
                                                                                    handleDateChange={(value, name, index) => {
                                                                                        const originalIndex = services[index]?.originalIndex;
                                                                                        if (originalIndex !== undefined) {
                                                                                            handleDateChange(value, name, originalIndex);
                                                                                        }
                                                                                    }}
                                                                                    handleSaveService={handleCreateUpdateServiceRateCard}
                                                                                    rateCardDetails={rateCardDetails}
                                                                                />
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    </Accordion>
                                                                </div>
                                                            </div>
                                                        );
                                                    });
                                                })()}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ServiceRateCard.propTypes = {
    isEditable: PropTypes.bool,
};

export default ServiceRateCard;